import { render } from "./MessageGroupAssignModal.vue?vue&type=template&id=102b2f53&scoped=true"
import script from "./MessageGroupAssignModal.vue?vue&type=script&lang=js"
export * from "./MessageGroupAssignModal.vue?vue&type=script&lang=js"

import "./MessageGroupAssignModal.vue?vue&type=style&index=0&id=102b2f53&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-102b2f53"]])

export default __exports__